export class MachineScheduleInterface {
  constructor(
    public HourShutDown: number,
    public MinutesShutDown: number,
    public HourDisplaysOff: number,
    public MinutesDisplaysOff: number,
    public HourDisplaysOn: number,
    public MinutesDisplaysOn: number,
    public PhysicalAddresses: string[] = [],
    public EnableRestart: boolean = false,
    public EnableShutdown: boolean = false,
    public EnableRestartApp: boolean = false,
    public EnableDisplaysOnAndOff: boolean = false
  ) { }
}
